import './styles/variables.css';
import './styles/global.css';

import { StickyHeader } from './components/StickyHeader';
import { Hero } from './sections/Hero';
import { Features } from './sections/Features';
import { Screenshots } from './sections/Screenshots';
import { Pricing } from './sections/Pricing';
import { Faq } from './sections/Faq';
import { Footer } from './sections/Footer';

export function App() {
  return (
    <>
      <StickyHeader />
      <main>
        <Hero />
        <Features />
        <Screenshots />
        <Pricing />
        <Faq />
        <Footer />
      </main>
    </>
  );
}
